/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObservableActionTypeResponse
 */
export interface ObservableActionTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservableActionTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservableActionTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservableActionTypeResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ObservableActionTypeResponse
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservableActionTypeResponse
     */
    defaultColourCode?: string;
}

/**
 * Check if a given object implements the ObservableActionTypeResponse interface.
 */
export function instanceOfObservableActionTypeResponse(value: object): value is ObservableActionTypeResponse {
    return true;
}

export function ObservableActionTypeResponseFromJSON(json: any): ObservableActionTypeResponse {
    return ObservableActionTypeResponseFromJSONTyped(json, false);
}

export function ObservableActionTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservableActionTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'defaultColourCode': json['defaultColourCode'] == null ? undefined : json['defaultColourCode'],
    };
}

export function ObservableActionTypeResponseToJSON(json: any): ObservableActionTypeResponse {
    return ObservableActionTypeResponseToJSONTyped(json, false);
}

export function ObservableActionTypeResponseToJSONTyped(value?: ObservableActionTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'sortOrder': value['sortOrder'],
        'defaultColourCode': value['defaultColourCode'],
    };
}

